import { v4 as uuidv4 } from "uuid";

let sessionTraceId: string | undefined;

export const createSessionTraceId = (): string => uuidv4();

export const getSessionTraceId = (initialSessionTraceId?: string): string => {
  if (sessionTraceId) {
    return sessionTraceId;
  }

  sessionTraceId = initialSessionTraceId || createSessionTraceId();
  return sessionTraceId;
};
